/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { elementHasClassName, str_trim, clip } from './util.js';

import {
	default_ajax_error_handler,
	default_ajax_app_error_handler,
	initManjaBackendFetch,
	postToBackend,
	postToBackend2,
	getFromBackend,
	getCachedScript
} from './fetch-util.js';

import { mj } from './page-mj.js';
import { $ } from '../other/jquery-hooked.js';
import { create_common_hooks } from './oc-container-compat.js';
import { focusFirstElement } from './dialog-util.js';

import { mjt } from './i18ntexts.js';

import { MCFactories } from './media.factories.js';

import { MPlugins } from './plugins.js';
import { MDObject } from './object-data.js';

import { MThumbnails } from './thumbnails.js';
import { more_select2_widget_init } from './select2.js';





var _mj_win_size = [100,100,false];


/**
 * initialize essential page utils
 */
function MVPage_init1() {

	MCFactories.init();

	mj.mc_names = {
		0: mjt('mc-0','!'),
		1: mjt('mc-1','!'),
		2: mjt('mc-2','!'),
		3: mjt('mc-3','!'),
		4: mjt('mc-4','!'),
		5: mjt('mc-5','!'),
		6: mjt('mc-6','!'),
		7: mjt('mc-7','!'),
		8: mjt('mc-8','!'),
	};

	initManjaBackendFetch();


	// - add postJSON(), postJSON2() and getJSON2() utility methods ...
	// - methods used in manja < 5 - kept for compatibility
	// - will deprecate later!
	$.postJSON = postToBackend;
	$.postJSON2 = postToBackend2;
	$.getJSON2 = getFromBackend;
	$.getCachedScript = getCachedScript;


	// run "pre" module specific initialization...
	$(document).triggerHandler('mjspreload');


	// set jquery ui dialog defaults
	var dialogDefaultOptions = {
		closeText: mjt('close'),
		resizable: false,
		minimizeText: mjt('minimize'),
		maximizable: false,
	};
	Object.assign( $.ui.dialog.prototype.options, dialogDefaultOptions );
	if( $.hasOwnProperty('jquery-ui') && $['jquery-ui'].hasOwnProperty('extendeddialog') ) {
		Object.assign( $['jquery-ui'].extendeddialog.prototype.options, dialogDefaultOptions );
	}

	// override tab handling in jquery ui dialog
	$.ui.dialog.prototype._focusTabbable = function mj_dlg_focusTabbable() {
		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// DISABLED: 5. The close button
		// 6. The dialog itself
		/*
		var hasFocus = this._focusedElement;
		if( !hasFocus ) hasFocus = this.element.find('[autofocus]');
		if( !hasFocus.length ) hasFocus = this.element.find('a,input,textarea,button,select,.select2-selection').filter(':tabbable');
		//WAY TOO SLOW IN SOME CASES://if( !hasFocus.length ) hasFocus = this.element.find(':tabbable');
		//DISABLED BECAUSE UNUSED in MJ://if( !hasFocus.length ) hasFocus = this.uiDialogButtonPane.find(':tabbable');
		//DISABLED://if( !hasFocus.length ) hasFocus = this.uiDialogTitlebarClose.filter(':tabbable');
		//if( !hasFocus.length ) hasFocus = this.uiDialog.attr('tabindex',-1);
		if( !hasFocus.length ) hasFocus = this.uiDialog;
		hasFocus.eq(0).trigger('focus');
		*/
		var focused_elem = this._focusedElement;
		if( !focused_elem ) focused_elem = focusFirstElement(this.element,true,false,false,true);
		if( focused_elem===null || focused_elem===undefined || focused_elem.length===0 ) focused_elem = this.uiDialog.trigger('focus');
	};

	var pseudo_sel_input_regex = /^(?:input|select|textarea|button)$/;
	Object.assign(
		$.expr.pseudos,
		{
			input: function( elem, index, selector ) {
				var name = elem.nodeName.toLowerCase();
				if( pseudo_sel_input_regex.test(name) ) return true;
				if( name==='span' && elementHasClassName(elem,'select2-selection') ) return true; // select2() wrapped <select> element
				return false;
			},
		}
	);

	// for compatibility of select2 with jquery ui dialog..
	var orig_allowInteraction = $.ui.dialog.prototype._allowInteraction;
	$.ui.dialog.prototype._allowInteraction = function mj_dlg_allowInteraction( event ) {
		// note: used only for 'focus' events
		if( event.target && event.target.nodeName=='#document' ) return true;
		if( $(event.target).closest('.cke_dialog,.cke_dialog_background_cover,.select2-dropdown,.colorpicker').length ) return true;
		return orig_allowInteraction.apply(this,arguments);
	};

	// window resize handler
	var mjs_win = $(window);
	_mj_win_size = [ mjs_win.width(), mjs_win.height(), !!window.fullScreen ];
	mjs_win.resize( _mj_window_resize );
	mjs_win = null; // release reference

	if( $.datepicker ) {
		// ui datepicker defaults
		$.datepicker.setDefaults( {
			changeYear: true,
			yearRange: '1900:' + ( (new Date()).getFullYear() + 20 ),
			changeMonth: true,
			gotoCurrent: false,
			showOtherMonths: true,
			selectOtherMonths: true,
			showButtonPanel: true,
			duration: 'fast',
		} );
	}

	// configure tablesorter - if loaded
	if( $.tablesorter ) {
		// default extractor for table data that is wrapped in one or two html elements,
		// and a special case for <span class='datetime' value='YYYY-MM-DD HH:MM:SS'>formatted date</span>
		const _mj_tablesorter_textExtraction = function( node, table, cellIndex ) {
			const txt = node.getAttribute('data-sort-value');
			// if( txt!==null && txt!=='' ) return txt;
			if( txt!==null ) {
				// NOTE: also return here, when it is an empty string (e.g. <td data-sort-value="">...</td>)
				return txt;
			}
			if( node.hasChildNodes() ) {
				const ncl = node.childNodes.length;
				for( var i=0; i<ncl; ++i ) {
					const childNode = node.childNodes[i];
					if( childNode.nodeType===Node.TEXT_NODE ) {
						// text node -> skip, if whitespace only
						if( str_trim(childNode.nodeValue)==='' ) continue;	// = skip node, check next one
						return node.innerHTML;								// = -> use outer nodes whole innerHTML for comparison
					}
					if( childNode.nodeType===Node.ELEMENT_NODE ) {
						// element node ...
						if( childNode.tagName==='B' || childNode.tagName==='I' || childNode.tagName==='A' ) return childNode.innerHTML;
						if( childNode.tagName==='SPAN' && ( childNode.className==='datetime' || childNode.hasAttribute('value') ) ) return childNode.getAttribute('value');
						if( childNode.hasChildNodes() && childNode.childNodes[0].nodeType===Node.ELEMENT_NODE ) return childNode.childNodes[0].innerHTML;
						return childNode.innerHTML;
					}
					// if( childNode.nodeType===Node.COMMENT_NODE ) {
					// 	// comment node -> skip
					// }
				}
			}
			return node.innerHTML;
		};
		$.tablesorter.defaults.textExtraction = _mj_tablesorter_textExtraction;

		// $.tablesorter.defaults.textExtraction = function( node, table, cellIndex ) {
		// 	const text = _mj_tablesorter_textExtraction(node,table,cellIndex);
		// 	const tr = node.parentElement;
		// 	const rowIndex = Array.from(tr.parentNode.children).indexOf(tr);
		// 	console.log({ri:rowIndex,ci:cellIndex,text});
		// 	return text;
		// };
	}

	more_select2_widget_init();


	// setup "longpress" delay on UI Touch Punch...: this means: all touch punch simulated mouse events from touch events will be triggered only after the configured delay ...
	// (so, scrolling on divs and other rather "direct interactional" stuff still works as without
	// touch punch, but most complex user interactions will be handled through touch punch!)
	/*if( 'ontouchend' in document ) {
		// ???
	}*/

	var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	if( iOS ) {
		// workaround for input focus strangeness on iOS (see https://stackoverflow.com/questions/15273098/how-do-i-stop-my-fixed-navigation-from-moving-like-this-when-the-virtual-keyboar/)
		$(document).on( 'focusin focusout', 'textarea,input,select,.select2-selection', function(e) {
			//console.log('FOCUSIN: '+e.type)
			$('body').toggleClass('input-focus-fix',e.type==='focusin');
		} );
	}

	// ui dialog automatic size & position ...

	const _getClampedDialogAutoHeight = function( dlg_inst_elem ) {
		const actual_dlg_height = dlg_inst_elem.closest('.ui-dialog').height();

		const inst_elem0_height2 = dlg_inst_elem[0].clientHeight;
		const abs_scroll_height = dlg_inst_elem[0].scrollHeight;
		const delta_scroll_height = abs_scroll_height - inst_elem0_height2;
		const max_dlg_height = actual_dlg_height + delta_scroll_height;

		const inst_elem0_vert_padding = ( parseFloat(dlg_inst_elem.css('paddingTop'))||0 ) + ( parseFloat(dlg_inst_elem.css('paddingBottom'))||0 );
		const min_dlg_height = max_dlg_height - abs_scroll_height + inst_elem0_vert_padding;

		const bnd_win_height = _mj_win_size[1]-20;
		const new_height = clip( bnd_win_height, min_dlg_height, Math.min(bnd_win_height,max_dlg_height) );

		// console.log({
		// 	'w':						'BFORE',
		// 	'actual_dlg_height':		actual_dlg_height,
		// 	'abs_scroll_height':		abs_scroll_height,
		// 	'inst_elem0_height2':		inst_elem0_height2,
		// 	'delta_scroll_height':		delta_scroll_height,
		// 	'min_dlg_height':			min_dlg_height,
		// 	'max_dlg_height':			max_dlg_height,
		// 	'bnd_win_height'	:		bnd_win_height,
		// 	'new_height':				new_height,
		// });

		return Math.round(new_height);
	};

	const _getClampedDialogAutoWidth = function( dlg_inst_elem ) {
		// const actual_dlg_width = dlg_inst_elem.closest('.ui-dialog').width();
		const actual_dlg_width = dlg_inst_elem.width(); // sufficient
		const bnd_win_width = _mj_win_size[0]-20;
		if( actual_dlg_width > bnd_win_width ) return bnd_win_width;
		return 'auto';
	};


	var orig_create = $.ui.dialog.prototype._create;
	var orig_setOption = $.ui.dialog.prototype._setOption;
	$.ui.dialog.prototype._create = function mj_dlg_create() {
		var o = this.options;
		if( o.width && 'function' === typeof (o.width) ) {
			o.dynWidth = o.width;
			o.width = null;
		}
		if( o.dynWidth ) o.width = o.dynWidth(_mj_win_size);
		if( o.height && 'function' === typeof (o.height) ) {
			o.dynHeight = o.height;
			o.height = null;
		}
		if( o.dynHeight ) o.height = o.dynHeight(_mj_win_size);
		const dlg_create_result = orig_create.apply(this,arguments);

		if( ( o.dynWidth && o.width==='auto' ) || ( o.dynHeight && o.height==='auto' ) ) {
			const self = this;
			requestAnimationFrame( function() {
				let updo = {};
				if( o.dynWidth && o.width==='auto' ) {
					// limit width to window width ..
					updo.width = _getClampedDialogAutoWidth(self.element);
				}
				if( o.dynHeight && o.height==='auto' ) {
					// limit height to window height ..
					updo.height = _getClampedDialogAutoHeight(self.element);
				}
				if( ( updo.hasOwnProperty('width') && updo.width!=='auto' ) || updo.hasOwnProperty('height') ) {
					// apply width and height, and trigger resize ..
					// NOTE: dialogs _setOption() does not trigger _size(), but _setOptions() does so:
					$.ui.dialog.prototype._setOptions.apply(self,[updo]);
				}
			} );
		}
		return dlg_create_result;
	};

	$.ui.dialog.prototype._setOption = function mj_dlg_setOption( k, v ) {
		if( k==='dynWidth' || ( k==='width' && 'function' === typeof (v) ) ) {
			this.options.dynWidth = v;
			return orig_setOption.apply(this,['width',v(_mj_win_size)]);
		} else if( k==='dynHeight' || ( k==='height' && 'function' === typeof (v) ) ) {
			this.options.dynHeight = v;
			return orig_setOption.apply(this,['height',v(_mj_win_size)]);
		}
		return orig_setOption.apply(this,arguments);
	};

	$(document).on( 'mjswinresize', $.debounce( 75, function(e,w,h,fs) {
		$('div.ui-dialog.ui-widget').each( function() {
			var dlg_inst_elem = $(this).find('.ui-dialog-content');
			var dlg = dlg_inst_elem.data('ui-dialog');
			var update_options = function( updo ) {
				dlg_inst_elem.dialog('option',updo);
			};
			if( !dlg ) {
				// support for jquery-ui.extendeddialog plugin ..
				dlg = dlg_inst_elem.data('jqueryUiExtendeddialog');
				update_options = function( updo ) {
					dlg_inst_elem.extendeddialog('option',updo);
				};
			}
			if( dlg && dlg.hasOwnProperty('options') ) {
				const o = dlg.options;
				let updo = {};
				if( o.position ) updo.position = o.position;
				if( o.dynWidth ) {
					updo.width = o.dynWidth(_mj_win_size);
					if( updo.width==='auto' ) {
						updo.width = _getClampedDialogAutoWidth(dlg_inst_elem);
					}
				}
				if( o.dynHeight ) {
					updo.height = o.dynHeight(_mj_win_size);
					if( updo.height==='auto' ) {
						updo.height = _getClampedDialogAutoHeight(dlg_inst_elem);
					}
				}
				update_options(updo);
			}
		} );
	} ) );
}


function MVPage_init2() {

	// run module specific initialization
	$(document).triggerHandler( 'mjsload' );

	// run basic components initialization
	MDObject.init();
	MPlugins.init();

	// common hooks
	create_common_hooks();

	// lazy size thumbnails
	if( 'lazySizes' in window ) window.lazySizes.init();

	// init thumbnails hooks
	if( MThumbnails ) MThumbnails.init();

	// add a simplified hash change handler
	if( window.MVPageHistory ) window.MVPageHistory.init(window);



	// beforeunload disables interactive elements on doc (only until a new doc shows up)
	/* UNCOMMENTED TO FAST FIX #382
	window.onbeforeunload = function ( e ) {
		//console.log(['onbeforeunload',e,e.currentTarget.document.activeElement]);
		var elem = e.currentTarget.document.activeElement;
		if( elem && elem.nodeName ) {
			if( elem.nodeName==='BODY' ) {
				// body is active? - this was not triggered through click on link or something like that
				return;
			} else if( 'hasAttribute' in elem ) {
				if( elem.hasAttribute('download') || elem.hasAttribute('data-download') ) {
					// event was triggered by click on download link
					// -> dont dim
					return;
				} else if( elementHasOneOfClassNames(elem,['select2-selection','select2','select2-container','batch-action']) || elem.nodeName=='SELECT' ) {
					// event was triggered by interaction with some dropdown ..
					// -> dont dim
					return;
				} else if( elem.hasAttribute('href') && !elem.hasAttribute('target') ) {
					// event was triggered by click on anchor > link element
					// -> dim
					//return; // NOT YET (must update custom templates and stuff first...) ?
				}
			}
		}
		//console.log(['REAL beforeunload',e]);
		$('button').prop('disabled',true);
		$('#search-form,div.xform,div.xdata,div.data,div.menu,div.item,.link').addClass('disabled');
	};
	*/
}



function _mj_window_resize( e ) {
	var lmjsw=$(window), w=lmjsw.width(), h=lmjsw.height(), fs=!!window.fullScreen;
	if( w!==_mj_win_size[0] || h!==_mj_win_size[1] || fs!==_mj_win_size[2] ) {
		_mj_win_size = [w,h,fs];
		window.setImmediate(MVPage_trigger_winresize);
	}
}



function MVPage_trigger_winresize( defered ) {
	if( defered ) return defered===true ? window.setImmediate(MVPage_trigger_winresize) : setTimeout(MVPage_trigger_winresize,defered);
	$(document).triggerHandler('mjswinresize',_mj_win_size);
}




// /**
//  * (provisional) module loader
//  * @example
//  *   mj_load_script_bundle('swfupload')
//  *     .then( function() {
//  *       // bundle successfully loaded ..
//  *       // ... your code ...
//  *     }, function( error ) {
//  *       // failed
//  *     });
//  *
//  * @param string bundle  script bundle name
//  * @param has_i18n
//  * @returns a Promise, resolving when load succeeds
//  */
// function mj_load_script_bundle( bundle, has_i18n ) {

// 	// TODO: detect & translate bundle 'ui_foo/foo'
// 	var url = 'g/js/entry/'+mj_make_filename(bundle);

// 	if( has_i18n ) url += '.'+mj.locale;
// 	if( mj.minify ) url += '.min';
// 	url += '.js?'+mj.cutag0;
// 	return $.getCachedScript(url);
// }

// /**
//  * load bundle when condition evaluates true
//  * @example
//  *   mj_load_script_bundle_if(!window.SWFUpload,'swfupload',false)
//  *     .then( function() {
//  *       // - either condition was false or was true and bundle successfully loaded ..
//  *       // ... your code ...
//  *     }, function( error ) {
//  *       // failed
//  *     });
//  *
//  * @param condition
//  * @param string bundle		script bundle name
//  * @param has_i18n
//  * @returns a Promise, resolved if condition was false, otherwise resolving when load succeeds
//  */
// function mj_load_script_bundle_if( condition, bundle, has_i18n ) {
// 	return condition ? mj_load_script_bundle(bundle,has_i18n) : Promise.resolve();
// }





export {
	MVPage_init1,
	MVPage_init2,
	MVPage_trigger_winresize,

	// for compat only - will deprecate, import from fetch-util.js instead..
	default_ajax_error_handler,
	default_ajax_app_error_handler
};
